'use client'
import React, { useEffect, useRef } from 'react'
import { useFormConfigContext } from 'src/components/era-package/forms/hooks/useFormConfig'
import AbiTradePartnerApiUrls from '../../../../../apiUrls/AbiTradePartnerApiUrls'
import { useWatch } from 'react-hook-form'

export const Interceptor = ({ asyncDefaultValues }) => {
  const isFirstLoad = useRef(true)
  const rhf = useFormConfigContext()
  const imptRecordNo = rhf.watch('header.importerOfRecordNumber')
  const imptRecordNoConfirm = rhf.watch('confirmation.importerOfRecordNumber')
  const afterDash = imptRecordNo?.split(' - ')[1]
  const partyLookup = useWatch({
    control: rhf.control,
    name: [
      'cargo.SE-partyMasterId',
      'cargo.BY-partyMasterId',
      'cargo.CN-partyMasterId',
      'cargo.ST-partyMasterId',
      'cargo.LG-partyMasterId',
      'cargo.CS-partyMasterId'
    ]
  })

  useEffect(() => {
    rhf.setValue(
      'confirmation.importerOfRecordNumber',
      imptRecordNoConfirm?.split(' - ')[0]
    )
  }, [imptRecordNoConfirm])

  useEffect(() => {
    // ...any other logic
    let isAlive = true
    if (!afterDash) {
      rhf.setValue('header.bond', [])
    } else {
      let newObj = {}
      if (asyncDefaultValues.header.importerOfRecordNumber === imptRecordNo) {
        if (asyncDefaultValues.header?.bond[0]?.bondDesignationType) {
          newObj = {
            ...newObj,
            bondDesignationType:
              asyncDefaultValues.header?.bond[0]?.bondDesignationType
          }
        } else {
          newObj = {
            ...newObj,
            bondDesignationType: 'B'
          }
        }
      } else {
        newObj = {
          ...newObj,
          bondDesignationType: 'B'
        }
      }

      if (isFirstLoad.current && asyncDefaultValues.header?.bond[0]) {
        newObj = {
          ...newObj,
          ...asyncDefaultValues.header?.bond[0]
        }
        rhf.setValue('header.bond', [newObj])
        isFirstLoad.current = false
      } else {
        fetch(AbiTradePartnerApiUrls.GET + `?id=${afterDash}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
          }
        })
          .then((res) => res.json())
          .then((json) => {
            newObj = {
              ...newObj,
              ...json.data
            }
            rhf.setValue('header.bond', [newObj])
          })
          .catch((err) => {
            console.error(err)
          })
      }

      return () => {
        isAlive = false
      }
    }
  }, [imptRecordNo])

  useEffect(() => {
    let isAlive = true
    partyLookup.forEach((item) => {
      if (item) {
        fetch(AbiTradePartnerApiUrls.GET + `?id=${item}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
          }
        })
          .then((res) => res.json())
          .then((json) => {
            let partyCode = json.data.partyCode
            if (json.data.partyCode === 'IM') {
              partyCode = 'CN'
            }
            const partyMasterName = `cargo.${partyCode}-partyMasterName`
            const currentPartyMasterName = rhf.getValues(partyMasterName)

            const name = `cargo.${partyCode}-name`
            const currentName = rhf.getValues(name)

            if (
              currentPartyMasterName !== json.data.partyMasterName &&
              currentName !== json.data.name
            ) {
              rhf.setValue(partyMasterName, json.data.partyMasterName)
              rhf.setValue(name, json.data.name)
              rhf.setValue(`cargo.${partyCode}-address1`, json.data.address1)
              rhf.setValue(`cargo.${partyCode}-address2`, json.data.address2)
              rhf.setValue(
                `cargo.${partyCode}-partyIdentifier`,
                json.data.partyIdentifier
              )
              rhf.setValue(`cargo.${partyCode}-duns`, json.data.duns)
              rhf.setValue(`cargo.${partyCode}-city`, json.data.city)
              rhf.setValue(
                `cargo.${partyCode}-stateProvince`,
                json.data.stateProvince
              )
              rhf.setValue(
                `cargo.${partyCode}-postalCode`,
                json.data.postalCode
              )
              rhf.setValue(
                `cargo.${partyCode}-countryCode`,
                json.data.countryCode
              )
            }
          })
          .catch((err) => {
            console.error(err)
          })

        return () => {
          isAlive = false
        }
      }
    })
  }, [partyLookup])

  // return empty node
  return <></>
}
